export default {"src":"/_next/static/media/videoPlay.4741aadf.svg","height":104,"width":105,"blurWidth":0,"blurHeight":0};